import {
  Box,
  Button,
  Checkbox,
  Collapse,
  makeStyles,
  Paper,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    borderRadius: theme.shape.borderRadius,
  },
  labelsColumn: {
    display: "flex",
    flexDirection: "column",
  },
  dataColumn: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginLeft: theme.spacing(2),
  },
  columnHeader: {
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  dataCell: {
    textAlign: "center",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
  },
  labelCell: {
    color: theme.palette.text.secondary,
    height: "2rem",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  hiddenHeader: {
    fontWeight: "bold",
    visibility: "hidden",
    marginBottom: theme.spacing(2),
  },
}));

export default function FilteredRow({
  id,
  rowData,
  index,
  checked,
  checkedHandler,
  convertDate,
  removeHandler,
}) {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  return (
    <>
      <TableRow>
        <TableCell>
          <Checkbox onChange={() => checkedHandler(index)} checked={checked} />
        </TableCell>
        <TableCell>{convertDate(rowData.createdAt)}</TableCell>
        <TableCell>{rowData.manufacturer}</TableCell>
        <TableCell>{rowData.model}</TableCell>
        <TableCell>{rowData.brand}</TableCell>
        <TableCell>{rowData.calibratorName}</TableCell>
        <TableCell>
          <Button
            onClick={() => {
              setOpen((prevOpen) => !prevOpen);
            }}
          >
            Info
          </Button>
          <Button
            onClick={() => {
              removeHandler(id);
            }}
          >
            Remove
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className={classes.root}>
              <Box className={classes.labelsColumn}>
                <Typography
                  variant="subtitle1"
                  className={classes.hiddenHeader}
                >
                  Hz
                </Typography>

                <Typography variant="body2" className={classes.labelCell}>
                  Głośność aplikacji:
                </Typography>
                <Typography variant="body2" className={classes.labelCell}>
                  Testowane względem:
                </Typography>
                <Typography variant="body2" className={classes.labelCell}>
                  Głośność główna:
                </Typography>
              </Box>

              {rowData.calibrations.map((calibration, index) => (
                <Box key={index} className={classes.dataColumn}>
                  <Typography
                    variant="subtitle1"
                    className={classes.columnHeader}
                  >
                    {calibration.freq} Hz
                  </Typography>

                  <Typography variant="body1" className={classes.dataCell}>
                    {calibration.appVolume}
                  </Typography>
                  <Typography variant="body1" className={classes.dataCell}>
                    {calibration.intensityTestedAgainst}
                  </Typography>
                  <Typography variant="body1" className={classes.dataCell}>
                    {calibration.masterVolume}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
